
const config = { 
  production:{
    URL: 'https://management.prod.fitvdev.com'
  },
  develop: {
    URL: 'https://management.dev.fitvdev.com'
  },
  default:{
    URL: 'http://localhost:4001'
  }
}

exports.get = function get(env){
  return config[env] || config.default;
}